// import notFound from './not-found.jpg';

function NotAllowed() {    
  return (
    <div className="App">
        {/*<img src={notFound} alt="Could not find a logged in account."/>*/}
        <p>No account found.</p>
        <p>Please create an account to view items on this page.</p>
    </div>
  );
}

export default NotAllowed;
